import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124.79 89.62" width="125" height="90" {...props}><path fill="currentColor" d="M46.11 89.62L0 44.46l10.5-10.72L45.98 68.5 114.16 0l10.63 10.58-78.68 79.04z" /></svg>);